import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Table, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

import OperationTimeScreen from './OperationTimeScreen';
import HeaderAndDays from './HeaderAndDays';
import { prependTimeWithZero, convertStringToBoolean } from '../../../utils/CommonUtils';
import { dispatchErrorMessage } from '../../../actions/index';

class TimeTableScreen extends Component {
    constructor() {
        super();

        this.state = {
            preparationTimes: [],
            selectedPreparationTime: {
                id: null,
                fromHour: null,
                fromMinute: null,
                toHour: null,
                toMinute: null,
                validOnMonday: false,
                validOnTuesday: false,
                validOnWednesday: false,
                validOnThursday: false,
                validOnFriday: false,
                validOnSaturday: false,
                validOnSunday: false,
                duration: 60,
                maxOrders: 10000,
                maxValue: null
            },
            isRequired: true,
            isPrepTimeChanged: false,
            isOperationTimeOpened: false
        }

        this.toggleModal = this.toggleModal.bind(this);
        this.openTimeScreen = this.openTimeScreen.bind(this);
        this.updatePreparationTimes = this.updatePreparationTimes.bind(this);
        // Binds for availability settings
        this.changeState = this.changeState.bind(this);
        this.changeBooleanAttributeState = this.changeBooleanAttributeState.bind(this);
    }

    componentDidMount() {
        this.copyStateFromProps(this.props.preparationTimes);
    }

    componentDidUpdate(prevProps) {
        if (this.props.preparationTimes !== prevProps.preparationTimes || this.props.showErrorMsg !== prevProps.showErrorMsg) {
            this.copyStateFromProps(this.props.preparationTimes);
        }
    }

    copyStateFromProps(times, callback) {
        const prepTimes = this.addIDsToPrepTimes(times);

        this.setState({
            ...this.state,
            preparationTimes: prepTimes,
            isPrepTimeChanged: this.props.showErrorMsg
        }, () => {
            if (callback) {
                callback();
            }
        });
    }

    addIDsToPrepTimes(times) {
        let transformedPrepTimes = [];

        times.map((prepTime, i) => {
            let transformedPrepTime = {
                id: !prepTime.id ? i : prepTime.id,
                fromHour: prepTime.fromHour,
                fromMinute: prepTime.fromMinute,
                toHour: prepTime.toHour,
                toMinute: prepTime.toMinute,
                validOnMonday: prepTime.validOnMonday,
                validOnTuesday: prepTime.validOnTuesday,
                validOnWednesday: prepTime.validOnWednesday,
                validOnThursday: prepTime.validOnThursday,
                validOnFriday: prepTime.validOnFriday,
                validOnSaturday: prepTime.validOnSaturday,
                validOnSunday: prepTime.validOnSunday,
                duration: prepTime.duration,
                maxOrders: prepTime.maxOrders,
                maxValue: prepTime.maxValue
            }

            transformedPrepTimes.push(transformedPrepTime);
        });

        return transformedPrepTimes;
    }

    toggleModal(resetSelectedPrepTime) {
        if (resetSelectedPrepTime) {
            this.setState({
                ...this.state,
                isOperationTimeOpened: !this.state.isOperationTimeOpened,
                selectedPreparationTime: {}
            });
        } else {
            this.setState({
                ...this.state,
                isOperationTimeOpened: !this.state.isOperationTimeOpened
            });
        }
    }

    openTimeScreen(selectedPreparationTime) {
        this.setState({
            ...this.state,
            selectedPreparationTime: selectedPreparationTime,
            isOperationTimeOpened: this.props.availabilitySettings ? this.state.isOperationTimeOpened : !this.state.isOperationTimeOpened
        });
    }

    updatePreparationTimes(preparationTime) {
        const { validOnMonday, validOnTuesday, validOnWednesday, validOnThursday, validOnFriday, validOnSaturday, validOnSunday } = preparationTime;
        const isNoDaySelected = !validOnMonday && !validOnTuesday && !validOnWednesday && !validOnThursday && !validOnFriday && !validOnSaturday && !validOnSunday;

        if (this.validateOverlappingPreparationTimes(preparationTime) && !isNoDaySelected) {
            let updatedPreparationTimes;

            if (preparationTime.id === undefined || preparationTime.id === null) {
                updatedPreparationTimes = this.state.preparationTimes.slice();
                preparationTime.id = updatedPreparationTimes.length + 1;
                updatedPreparationTimes.push(preparationTime);
            } else {
                updatedPreparationTimes = [];
                this.state.preparationTimes.map(currentPreparationTime => {
                    if (preparationTime.id === currentPreparationTime.id) {
                        updatedPreparationTimes.push(preparationTime);
                    } else {
                        updatedPreparationTimes.push(currentPreparationTime);
                    }
                });
            }

            if (this.props.availabilitySettings) {
                // This check removes the unnecessary properties duration, maxOrders, maxValue for availability
                // these three props are needed only for the time slot logic
                let prepTimesWithoutExcessProperties = [];
                
                updatedPreparationTimes.map(prepTime => {
                    // console.log('preptime ', prepTime);
                    let prepTimeCopy = { ...prepTime };
                    delete prepTimeCopy.duration;
                    delete prepTimeCopy.maxOrders;
                    delete prepTimeCopy.maxValue;
                    prepTimesWithoutExcessProperties.push(prepTimeCopy);
                });
                updatedPreparationTimes = prepTimesWithoutExcessProperties;
            }

            this.setState({
                ...this.state,
                isOperationTimeOpened: !this.props.availabilitySettings ? !this.state.isOperationTimeOpened : this.state.isOperationTimeOpened,
                selectedPreparationTime: {
                    id: null,
                    fromHour: null,
                    fromMinute: null,
                    toHour: null,
                    toMinute: null,
                    validOnMonday: false,
                    validOnTuesday: false,
                    validOnWednesday: false,
                    validOnThursday: false,
                    validOnFriday: false,
                    validOnSaturday: false,
                    validOnSunday: false,
                    duration: null,
                    maxOrders: null,
                    maxValue: null
                },
                isRequired: false,
                isPrepTimeChanged: true
            });

            this.props.updatePrepTimes(updatedPreparationTimes, () => {
                this.setState({
                    ...this.state,
                    isPrepTimeChanged: false
                });
            });

            return true;
        } else {
            if (isNoDaySelected) {
                this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.noDaySelected'));
            } else if (this.props.availabilitySettings) {
                this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.availablityOverlaps'));
            } else {
                this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.workTimeOverlaps'));
            }
            return false;
        }
    }

    validateOverlappingPreparationTimes(preparationTime) {
        const { preparationTimes } = this.state;

        for (let i = 0; i < preparationTimes.length; i++) {
            const currentPreparationTime = preparationTimes[i];
            if (preparationTime.id === currentPreparationTime.id) {
                continue;
            }

            if ((preparationTime.validOnMonday && currentPreparationTime.validOnMonday) ||
                (preparationTime.validOnTuesday && currentPreparationTime.validOnTuesday) ||
                (preparationTime.validOnWednesday && currentPreparationTime.validOnWednesday) ||
                (preparationTime.validOnThursday && currentPreparationTime.validOnThursday) ||
                (preparationTime.validOnFriday && currentPreparationTime.validOnFriday) ||
                (preparationTime.validOnSaturday && currentPreparationTime.validOnSaturday) ||
                (preparationTime.validOnSunday && currentPreparationTime.validOnSunday)) {

                const moment = extendMoment(Moment);
                let preparationTimeRange, currentPreparationTimeRange;
                // if the end time is after midnight and the start time is before midnight, then we add a day to the end time, 
                // because if we don't add a day, then the moment library will think that the end time which is after midnight will be
                // for the same day as the start time.
                // const isMidnightFromHour = preparationTime.fromHour > 0 && preparationTime.fromHour <= 8? true : false;
                const isPrepTimeMidnightToHour = preparationTime.toHour >= 0 && preparationTime.toHour < 8 ? true : false;
                const isCurrentPrepTimeMidnightToHour = currentPreparationTime.toHour >= 0 && currentPreparationTime.toHour < 8 ? true : false;

                if(isPrepTimeMidnightToHour) {
                    preparationTimeRange = moment.range(
                        moment(`${preparationTime.fromHour}:${preparationTime.fromMinute}`, 'HH:mm'),
                        moment(`${preparationTime.toHour}:${preparationTime.toMinute}`, 'HH:mm').add(1, 'days'));
                } else {
                    preparationTimeRange = moment.range(
                        moment(`${preparationTime.fromHour}:${preparationTime.fromMinute}`, 'HH:mm'),
                        moment(`${preparationTime.toHour}:${preparationTime.toMinute}`, 'HH:mm'));
                }

                if(isCurrentPrepTimeMidnightToHour) {
                    currentPreparationTimeRange = moment.range(
                        moment(`${currentPreparationTime.fromHour}:${currentPreparationTime.fromMinute}`, 'HH:mm'),
                        moment(`${currentPreparationTime.toHour}:${currentPreparationTime.toMinute}`, 'HH:mm').add(1, 'days'));
                } else {
                    currentPreparationTimeRange = moment.range(
                        moment(`${currentPreparationTime.fromHour}:${currentPreparationTime.fromMinute}`, 'HH:mm'),
                        moment(`${currentPreparationTime.toHour}:${currentPreparationTime.toMinute}`, 'HH:mm'));
                }
                
                if (preparationTimeRange.overlaps(currentPreparationTimeRange) || preparationTimeRange.isSame(currentPreparationTimeRange)) {

                    return false;
                }
            }
        }

        return true;
    }

    renderWarningMessage() {
        if (this.state.isPrepTimeChanged) {
            return (
                <p style={{ color: '#dc3545', fontSize: '80%', marginTop: 20, marginRight: 20 }}>{i18n.t('common:validations.saveWarningMsg')}</p>
            );
        }
    }

    renderTableRows() {
        const { itemAvailableAllDay } = this.props;

        return this.state.preparationTimes.map((preparationTime, index) => {
            const prependTime = `${prependTimeWithZero(preparationTime.fromHour)}:${prependTimeWithZero(preparationTime.fromMinute)} -
                                 ${prependTimeWithZero(preparationTime.toHour)}:${prependTimeWithZero(preparationTime.toMinute)}`;
            const tdStyle = !this.props.availabilitySettings ? {} : { padding: 5 };

            return (
                <tr hidden={itemAvailableAllDay} key={`prepTime${index}`}>
                    <td style={tdStyle}>{prependTime}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnMonday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnTuesday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnWednesday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnThursday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnFriday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnSaturday)}</td>
                    <td style={tdStyle}>{this.renderPreparationTimeDayColumn(preparationTime.validOnSunday)}</td>
                    {
                        this.props.timeSlotBased &&
                        <Fragment>
                            <td style={tdStyle}>{preparationTime.duration}</td>
                            <td style={tdStyle}>{preparationTime.maxOrders ? preparationTime.maxOrders : '-'}</td>
                            <td style={tdStyle}>{preparationTime.maxValue ? preparationTime.maxValue : '-'}</td>
                        </Fragment>
                    }
                    {
                        !this.props.readOnly &&
                        <td style={{ width: '140px', textAlign: 'center' }}>
                            <Button color="link" onClick={() => this.openTimeScreen(preparationTime)} disabled={itemAvailableAllDay}>
                                <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={28} />
                            </Button>
                            <Button color="link" onClick={() => this.deletePreparationTime(preparationTime)} disabled={itemAvailableAllDay}>
                                <MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={28} />
                            </Button>
                        </td>
                    }
                </tr>
            );
        });
    }

    deletePreparationTime(preparationTime) {
        const updatedPreparationTimes = [];

        this.state.preparationTimes.map(currentPreparationTime => {
            if (preparationTime.id !== currentPreparationTime.id) {
                updatedPreparationTimes.push(currentPreparationTime);
            }
        });

        this.props.updatePrepTimes(updatedPreparationTimes, () => {
            this.setState({
                ...this.state,
                preparationTimes: updatedPreparationTimes
            });
        });
    }

    renderPreparationTimeDayColumn(validOnThatDay) {
        if (validOnThatDay) {
            return (
                <MaterialIcon icon="check" color="rgb(117, 159, 46)" size={28} />
            );
        } else {
            return null;
        }
    }

    changeState({ target }) {
        this.setState({
            selectedPreparationTime: {
                ...this.state.selectedPreparationTime,
                [target.name]: parseInt(target.value)
            },
            isRequired: true
        });
    }

    changeBooleanAttributeState({ target }) {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            selectedPreparationTime: {
                ...this.state.selectedPreparationTime,
                [target.name]: checked
            }
        });
    }

    render() {
        const { availabilitySettings, itemAvailableAllDay, readOnly } = this.props;
        let tableHolder = availabilitySettings ? { width: '100%' } : { width: this.props.readOnly ? '100%' : 'calc(100% - 200px)' };
        let tableHolderRow = availabilitySettings ? { padding: '16px 0 0 16px' } : { padding: '0 0 0 16px' };
        let thStyle = !availabilitySettings ? { backgroundColor: 'rgba(204, 204, 204, 0.24)' } : { backgroundColor: 'rgba(204, 204, 204, 0.24)', padding: 5 }
        const { fromHour, fromMinute, toHour, toMinute } = this.state.selectedPreparationTime;
        let isDisabled = fromHour === null || fromMinute === null || toHour === null || toMinute === null;
        return (
            <Fragment>
                {
                    availabilitySettings && !itemAvailableAllDay ?
                        <Fragment>
                            <Row style={{ padding: '0 0 0 16px' }}>
                                <HeaderAndDays
                                    preparationTime={this.state.selectedPreparationTime}
                                    isRequired={this.state.isRequired}
                                    changeState={this.changeState}
                                    changeCheckBoxState={this.changeBooleanAttributeState}
                                    availabilitySettings={this.props.availabilitySettings}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '12px 0 0 0' }} >
                                        {this.renderWarningMessage()}
                                        <Button
                                            disabled={isDisabled} color="primary"
                                            onClick={() => this.updatePreparationTimes(this.state.selectedPreparationTime)} >
                                            <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                                        </Button>
                                    </div>
                                </HeaderAndDays>
                            </Row>

                        </Fragment> : null
                }

                <Row style={tableHolderRow}>
                    <div style={tableHolder}>
                        <Table responsive hidden={this.props.itemAvailableAllDay}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.fromTo')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.mon')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.tue')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.wed')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.thu')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.fri')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.sat')}</th>
                                    <th style={thStyle}>{i18n.t('screens:preparationTimes.sun')}</th>
                                    {
                                        this.props.timeSlotBased &&
                                        <Fragment>
                                            <th style={thStyle}>{i18n.t('screens:preparationTimes.duration')}</th>
                                            <th style={thStyle}>{i18n.t('screens:preparationTimes.maxOrders')}</th>
                                            <th style={thStyle}>{i18n.t('screens:preparationTimes.maxValue')}</th>
                                        </Fragment>
                                    }
                                    {
                                        !this.props.readOnly &&
                                        <th style={thStyle}></th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTableRows()}
                            </tbody>
                        </Table>
                    </div>

                    {
                        !availabilitySettings && !readOnly ?
                            <div style={{ width: 200, display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }} >
                                <Button color="primary" onClick={this.toggleModal} >
                                    <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:operationTimeScreen.addTimePeriod')}
                                </Button>
                                {this.renderWarningMessage()}
                            </div> : null
                    }

                    {
                        this.state.isOperationTimeOpened ?
                            <OperationTimeScreen
                                isOpen={this.state.isOperationTimeOpened}
                                toggle={this.toggleModal}
                                timeSlotBased={this.props.timeSlotBased}
                                selectedPreparationTime={this.state.selectedPreparationTime}
                                save={this.updatePreparationTimes}
                                dispatchErrorMessage={this.props.dispatchErrorMessage}
                            /> : null
                    }
                </Row>
            </Fragment>
        );
    }
}

export default connect(null, { dispatchErrorMessage })(TimeTableScreen);


// WEBPACK FOOTER //
// ./src/components/common/operationHours/TimeTableScreen.js